import React, { Component } from 'react';
import { Switch, Route, Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {
        USER: state.USER,
        PENDING_ORDERS: state.PENDING_ORDERS,
        UNREAD_MESSAGES: state.UNREAD_MESSAGES,
        PENDING_TENDERS: state.PENDING_TENDERS
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class LeftNav extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);
        this.state = {
            NAV_OPENED: false
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    getNavsItemsList = () => {
        return [
            {
                title: 'Главная',
                path: '/',
                active: '/system_images/navs/home_active.png',
                inactive: '/system_images/navs/home_inactive.png'
            },
            {
                title: 'Товары',
                path: '/products',
                active: '/system_images/navs/products_active.png',
                inactive: '/system_images/navs/products_inactive.png'
            },
            {
                title: 'QR на товары',
                path: '/qr',
                active: '/system_images/navs/qr_active.png',
                inactive: '/system_images/navs/qr_inactive.png'
            },
            {
                title: 'Чат с нами',
                path: '/chat',
                active: '/system_images/navs/products_active.png',
                inactive: '/system_images/navs/products_inactive.png'
            },
            {
                title: 'Жалобы на товары',
                path: '/complaints',
                active: '/system_images/navs/complaints_active.png',
                inactive: '/system_images/navs/complaints_inactive.png'
            },
            {
                title: 'Заказы',
                path: '/orders',
                active: '/system_images/navs/assortment_active.png',
                inactive: '/system_images/navs/assortment_inactive.png'
            },
            {
                title: 'Тендеры',
                path: '/tenders',
                active: '/system_images/navs/tender_active.png',
                inactive: '/system_images/navs/tender_inactive.png'
            },
            // {
            //     title: 'Тендер',
            //     path: '/assortment',
            //     active: '/system_images/navs/assortment_active.png',
            //     inactive: '/system_images/navs/assortment_inactive.png'
            // },
            // {
            //     title: 'Продажи',
            //     path: '/sales',
            //     active: '/system_images/navs/sales_active.png',
            //     inactive: '/system_images/navs/sales_inactive.png'
            // },
            // {
            //     title: 'Отзывы',
            //     path: '/comments',
            //     active: '/system_images/navs/comments_active.png',
            //     inactive: '/system_images/navs/comments_inactive.png'
            // },
            // {
            //     title: 'Бухгалтерия',
            //     path: '/buh',
            //     active: '/system_images/navs/buh_active.png',
            //     inactive: '/system_images/navs/buh_inactive.png'
            // },
            // {
            //     title: 'График поставок',
            //     path: '/calendar',
            //     active: '/system_images/navs/calendar_active.png',
            //     inactive: '/system_images/navs/calendar_inactive.png'
            // },
            {
                title: 'Реклама',
                path: '/marketing',
                active: '/system_images/navs/marketing_active.png',
                inactive: '/system_images/navs/marketing_inactive.png'
            }
        ];
    }

    checkActiveRoute = (path) => {
        if (path == this.props.location.pathname) {
            return true;
        }

        return false;
    }

    renderAddons = (path) => {
        if (path == '/orders') {
            if (this.props.PENDING_ORDERS > 0) {
                return <span className="nav_counter">{ this.props.PENDING_ORDERS }</span>
            }
        } else if (path == '/chat') {
            if (this.props.UNREAD_MESSAGES > 0) {
                return <span className="nav_counter">{ this.props.UNREAD_MESSAGES }</span>
            }
        } else if (path == '/tenders') {
            if (this.props.PENDING_TENDERS > 0) {
                return <span className="nav_counter">{ this.props.PENDING_TENDERS }</span>
            }
        }
    }

    renderNavs = () => {
        let NAVS = this.getNavsItemsList();
        let ITEMS = [];
        for (let i = 0; i < NAVS.length; i++) {
            let ITEM = NAVS[i];
            let active = this.checkActiveRoute(ITEM.path);
            let image = ITEM.inactive;
            let item_class = '';

            if (active) {
                image = ITEM.active;
                item_class = ' active';
            }

            ITEMS.push(
                <Link key={ i } className={ item_class } to={ ITEM.path }><span><img src={ image } /></span>{ ITEM.title }{ this.renderAddons(ITEM.path) }</Link>
            );
        }

        let NEWS_LINK = <Link to="/news"><span><img src="/system_images/navs/news_inactive.png" /></span>Новости</Link>;
        if (this.checkActiveRoute('/news')) {
            NEWS_LINK = <Link className="active" to="/news"><span><img src="/system_images/navs/news_active.png" /></span>Новости</Link>;
        }

        return (
            <div className={ "left_navs" + this.addNavClass() }>
                { ITEMS }
                <div className="left_navs_separator"></div>
                { NEWS_LINK }
                <div className="mobile_logout">
                    <div className="left_navs_separator"></div>
                    <a onClick={ () => this.props.logOut() }>
                        <span><img src="/system_images/logout.png" /></span>Выход
                    </a>
                </div>
            </div>
        );
    }

    addNavClass = () => {
        if (this.state.NAV_OPENED) {
            return ' opened';
        }

        return '';
    }

    render() {
        return (
            <div className="left_bar">
                <div className="left_logo">
                    <img src="/system_images/logo.png" />
                    <span>Ecomarket.ru</span>
                    <div>
                        <a className="mobile_nav" onClick={ () => this.setState({ NAV_OPENED: !this.state.NAV_OPENED }) }>
                            <img src="/system_images/menu.png" />
                        </a>
                    </div>
                </div>

                { this.renderNavs() }
            </div>
        );
    }

}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(LeftNav))